app.controller('articleCalculator', function ($scope, $sce, dataService) {
    $scope.currentStep = 1;
    $scope.optionVal = '';
    $scope.calculation = {
        weight: '',
        weightUnit: 'kg',
        maxResult: '',
        repetitions: '',
    };

    $scope.setCurrentStep = function(step) {
        $scope.currentStep = step;
    };

    $scope.calculate = function() {
        if ($scope.calculation.weight && $scope.calculation.repetitions) {
            $scope.calculation.maxResult = $scope.roundResults($scope.calculation.weight*(36/(37-$scope.calculation.repetitions)));
            $scope.modifyOptionVal();
            $scope.currentStep = 4;
        }
    };

    $scope.roundResults = function(value) {
        let decimal = value - Math.floor(value);
        return decimal ? parseFloat(value).toFixed(1) : value;
    };

    $scope.modifyOptionVal = function() {
        $scope.optionVal = dataService.modifyOptionVal($scope.calculation.maxResult, $scope.calculation.weightUnit, 3, 7, 9);
    };
});